import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "@jumbo/components/GridContainer";

import { baseUrl } from "@jumbo/constants/baseUrl";
import axios from "../../../services/auth/jwt/config";

const useStyles = makeStyles(() => ({
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  formControl: {
    width: "100%",
  },
}));

export default function HubbleReportDialog({ open, handleClose }) {
  const classes = useStyles();
  const [selectedLevel, setSelectedLevel] = useState("Level1");

  const handleGetReport = async () => {
    const downloadUrl = `${baseUrl}hubble/report/${selectedLevel}`;
    try {
      const response = await axios.get(downloadUrl, {
        responseType: "blob",
      });
      const contentDisposition = response.headers["content-disposition"];
      let filename = "default-filename.xlsx";
      if (contentDisposition) {
        const filenameRegex = /filename\*=UTF-8''([^;]+)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches && matches[1]) {
          filename = decodeURIComponent(matches[1]);
        } else {
          const regularFilenameRegex = /filename="([^"]+)"/;
          const regularMatches = regularFilenameRegex.exec(contentDisposition);
          if (regularMatches && regularMatches[1]) {
            filename = regularMatches[1];
          }
        }
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download the file", error);
    }
    handleClose();
    reset();
  };

  const reset = () => {
    setSelectedLevel("Level1");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-add-user-access"
      aria-describedby="alert-add-user-access"
      fullWidth
      maxWidth={"sm"}
    >
      <DialogContent>
        <DialogContentText id="alert-add-user-description">
          دریافت گزارش
        </DialogContentText>
        <GridContainer className={classes.girdContainer}>
          <Grid item xs={12}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="level-select-outlined-label">
                مرحله
              </InputLabel>
              <Select
                labelId="level-select-outlined-label"
                id="level-select-outlined"
                value={selectedLevel}
                onChange={(e) => setSelectedLevel(e.target.value)}
                label="مرحله"
              >
                <MenuItem value={"Level1"}>مرحله انتخابی</MenuItem>
                <MenuItem value={"Level2"}>مرحله مقدماتی</MenuItem>
                <MenuItem value={"Level3"}>مرحله نیمه نهایی</MenuItem>
                <MenuItem value={"Level4"}>مرحله نهایی</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleGetReport} color="primary">
          دریافت
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
